<template>
  <div class="w-100">
    <bar-manut :single-entity="titleForm" :crud="this.crud" @closeform="closeForm" @save="handleSave"
      :disable-retorno="disableRetorno" v-if="!guide">
    </bar-manut>

    <tabs :tabs="filteredTabs" :setActiveTab="activeTab" @onClickTab="changeTab" class="mb-4" v-if="!guide"></tabs>

    <!-- <h4 v-if="guide">{{ activeTabTitle }}</h4> -->

    <div>
      <!-- <div class="" :class="{'default-container': !guide}"> -->
      <div class="">
        <!-- <div class="default-container"> -->
        <!-- MENSAGENS DE VALIDACAO -->
        <validation v-if="errmessages.length" title="Erros de Validação" :messages="errmessages"></validation>
        <!-- FIM MENSAGENS DE VALIDACAO -->
        <div id="tabDAdos" v-if="tabDados">
          <div class="row">
            <div class="col-md-12 col-12">
              <label-title title="Dados da Empresa"></label-title>
              <div class="row">
                <form-field ref="cnpj" v-model="filial.cnpj" type="cnpj" col="2" :metadata="metadata.filial.cnpj"
                  name="cnpj" id="cnpj" :v-errors="errors" v-validate="metadata.filial.cnpj.validator">
                </form-field>
                <v-button v-if="showPreencherCadastro" label="Preencher Cadastro" icon=""
                  @click="handlePreencherCadastro()" title="Para uma pesquisa mais completa, informe o estado!">
                </v-button>
              </div>
              <div class="row mb-2">
                <div class="col-md-12 col-12">
                  <v-label label="Token integração com sistemas ERP"></v-label>
                </div>
                <div class="col-md-12 col-12">
                  <span class="data-list"> {{ tokenEmpresa }} </span>
                </div>
              </div>
              <div class="row">
                <form-field ref="nome" v-model="filial.nome" type="text" col="6" :metadata="metadata.filial.nome"
                  name="nome" id="nome" :v-errors="errors" v-validate="metadata.filial.nome.validator"></form-field>
              </div>
              <div class="row">
                <form-field v-model="filial.fantasia" type="text" col="6" :metadata="metadata.filial.fantasia"
                  nome="fantasia" id="fantasia" :v-errors="errors" v-validate="metadata.filial.fantasia.validator">
                </form-field>
              </div>
              <div class="row">
                <form-field v-model="tipo_ie" type="select" col="4"
                  label="Inscrição Estadual (Situação)" :select-options="tipo_ie_options" name="tipo_ie" id="tipo_ie">
                </form-field>
                <form-field :disabled="tipo_ie !== 'COM_IE'" v-model="filial.iest" type="text" col="4"
                  :metadata="metadata.filial.iest" name="iest" id="iest" :v-errors="errors"
                  v-validate="tipo_ie === 'COM_IE' ? metadata.filial.iest.validator : ''"></form-field>
              </div>
              <div class="row">
                <form-field v-model="filial.crt" type="select" col="4" name="crt" id="crt"
                  :metadata="metadata.filial.crt"></form-field>
                <form-field v-if="filial.crt != '3'" v-model="filial.pcredsn" type="value" col="4" addon="%"
                  :metadata="metadata.filial.pcredsn" name="pcredsn" id="pcredsn" :v-errors="errors"
                  v-validate="metadata.filial.pcredsn.validator"></form-field>
              </div>
              <div class="row" v-if="filial.crt != '1' && filial.crt != '4'">
                <form-field v-model="filial.apis" type="value" col="2" :metadata="metadata.filial.apis" :precision="2"
                  v-if="filial.crt != '1' && filial.crt != '4'" name="apis" :v-errors="errors"
                  v-validate="metadata.filial.apis.validator"></form-field>
                <form-field v-model="filial.acofins" type="value" col="2" :metadata="metadata.filial.acofins"
                  :precision="2" v-if="filial.crt != '1' && filial.crt != '4'" name="acofins" :v-errors="errors"
                  v-validate="metadata.filial.acofins.validator"></form-field>
              </div>

              <div class="row" v-if="filial.crt != '1' && filial.crt != '4'">
                <form-field v-model="filial.filialcclass" type="select2" col="4"
                  :metadata="metadata.filial.filialcclass" :disabled="isView" name="filialcclass" :v-errors="errors"
                  v-validate="metadata.filial.filialcclass.validator" parent="mymodal"
                  :select2="{ entity: 'ivaclass', minlength: 0 }"></form-field>
                <!--
                <form-field v-model="filial.aliquotaibsmun" type="value" col="2"
                  :metadata="metadata.filial.aliquotaibsmun" :precision="2"
                  v-if="filial.crt != '1' && filial.crt != '4'" name="aliquotaibsmun" :v-errors="errors"
                  v-validate="metadata.filial.aliquotaibsmun.validator"></form-field>
                 -->
                <form-field v-model="filial.aliquotaibsuf" type="value" col="2"
                  :metadata="metadata.filial.aliquotaibsuf" :precision="2" v-if="filial.crt != '1' && filial.crt != '4'"
                  name="aliquotaibsuf" :v-errors="errors" v-validate="metadata.filial.aliquotaibsuf.validator">
                </form-field>
                <form-field v-model="filial.aliquotacbs" type="value" col="2" :metadata="metadata.filial.aliquotacbs"
                  :precision="2" v-if="filial.crt != '1' && filial.crt != '4'" name="aliquotacbs" :v-errors="errors"
                  v-validate="metadata.filial.aliquotacbs.validator">
                </form-field>

              </div>

            </div>
            <div class="col-md-5 col-12">
            </div>
          </div>
          <label-title title="Logotipo"></label-title>
          <div class="row">
            <div class="col-md-6 col-12">
              <div v-if="filial.codfil" style="padding: 10px;" data-toggle="tooltip" data-placement="bottom">
                <img v-if="image" :src="image" class="img-thumbnail d-block" alt="Logotipo"
                  style="max-width: 130px; max-height: 130px; cursor: pointer;"
                  @click="handleClickLogotipo(filial.codfil)" />
                <span v-if="image" class="data-list text-danger" style="cursor: pointer"
                  @click="apiDeleteImage"><small><i class="fa fa-trash" aria-hidden="true"></i> Remover
                    Imagem
                  </small></span>
                <i v-if="!image" class="fa fa-camera d-block" style="font-size: 72px; color: silver; cursor: pointer"
                  @click="handleClickLogotipo(filial.codfil)"></i>

                <span v-if="!image" class="data-list" style="cursor: pointer"
                  @click="handleClickLogotipo(filial.codfil)">Selecionar Imagem</span>
              </div>
              <div class="row">
                <input v-show="false" id="anexo" type="file" ref="file" accept="image/*"
                  @change="handleUpload($event)" />
              </div>
            </div>
          </div>
          <div class="w-100 mt-1"></div>
          <label-title title="Endereço"></label-title>
          <div class="row">
            <form-field v-model="filial.cep" type="cep" col="2" :metadata="metadata.filial.cep" name="cep" id="cep"
              :v-errors="errors" v-validate="metadata.filial.cep.validator" @update="updateCep"></form-field>
            <div class="w-100"></div>
            <form-field v-model="filial.ende" type="text" col="6" :metadata="metadata.filial.ende" name="ende" id="ende"
              :v-errors="errors" v-validate="metadata.filial.ende.validator"></form-field>
            <form-field v-model="filial.endenr" type="text" col="2" :metadata="metadata.filial.endenr" name="endenr"
              id="endenr" :v-errors="errors" v-validate="metadata.filial.endenr.validator"></form-field>
            <form-field v-model="filial.endecomp" type="text" col="2" :metadata="metadata.filial.endecomp"
              name="endecomp" id="endecomp" :v-errors="errors" v-validate="metadata.filial.endecomp.validator">
            </form-field>
            <div class="w-100"></div>
            <form-field v-model="filial.bairro" type="text" col="3" :metadata="metadata.filial.bairro" name="bairro"
              id="bairro" :v-errors="errors" v-validate="metadata.filial.bairro.validator"></form-field>
            <form-field v-model="filial.uf" type="select2" col="3" :metadata="metadata.filial.uf" name="uf" id="uf"
              :v-errors="errors" v-validate="metadata.filial.uf.validator"></form-field>
            <form-field v-model="filial.codmun" type="select2" col="3" :metadata="metadata.filial.codmun" name="codmun"
              id="codmun" :v-errors="errors" v-validate="metadata.filial.codmun.validator"
              :select2="{ entity: 'mun/uf/' + filial.uf, minlength: 2 }"></form-field>
          </div>
          <div class="row">
            <form-field v-model="filial.fone1" type="fone" col="2" :metadata="metadata.filial.fone1" name="fone1"
              :v-errors="errors" v-validate="metadata.filial.fone1.validator"></form-field>
            <form-field v-model="filial.fone2" type="fone" col="2" :metadata="metadata.filial.fone2" name="fone2"
              :v-errors="errors" v-validate="metadata.filial.fone2.validator"></form-field>
            <form-field v-model="filial.fone3" type="fone" col="2" :metadata="metadata.filial.fone3" name="fone3"
              :v-errors="errors" v-validate="metadata.filial.fone3.validator"></form-field>
            <form-field v-model="filial.email" type="email" col="6" :metadata="metadata.filial.email" name="email"
              :v-errors="errors" v-validate="metadata.filial.email.validator"></form-field>
          </div>
          <div class="row">
            <form-field v-model="filial.site" type="text" col="6" :metadata="metadata.filial.site" name="site"
              :v-errors="errors" v-validate="metadata.filial.site.validator" :validateDisabledKeys="false"></form-field>
          </div>
        </div>

        <div v-if="appNFe">
          <!-- <label-title title="Informações Fiscais"></label-title><br> -->
          <div class="row">
            <!-- <form-field v-model="filial.imun" type="number" col="3" :metadata="metadata.filial.imun"
                        name="imun" :v-errors="errors" v-validate="metadata.filial.imun.validator"></form-field> -->
            <!-- <form-field v-model="filial.cnae" type="number" col="3" :metadata="metadata.filial.cnae"
                        name="cnae" :v-errors="errors" v-validate="metadata.filial.cnae.validator"></form-field> -->

            <!-- CAMPOS DO SPED DESABILITADOS -->
            <!-- <form-field v-model="filial.identjuntacom" type="number" col="3" :metadata="metadata.filial.identjuntacom"
                        name="identjuntacom" :v-errors="errors" v-validate="metadata.filial.identjuntacom.validator"></form-field>
                    <form-field v-model="filial.tipoestab" type="select" col="3" :metadata="metadata.filial.tipoestab"
                        name="tipoestab" :v-errors="errors" v-validate="metadata.filial.tipoestab.validator"></form-field>
                    <form-field v-if="filial.crt!='1'" v-model="filial.indapuripi" type="select" col="3" :metadata="metadata.filial.indapuripi"></form-field>
                    <form-field v-model="filial.perfilsped" type="select" col="3" :metadata="metadata.filial.perfilsped"></form-field>
                    <form-field v-model="filial.indatividade" type="select2" col="3" :metadata="metadata.filial.indatividade"
                        name="indatividade" :v-errors="errors" v-validate="metadata.filial.indatividade.validator"></form-field>
                    -->
            <!-- <form-field v-model="filial.regtribmun" type="select2" col="3" :metadata="metadata.filial.regtribmun"
                        name="regtribmun" :v-errors="errors" v-validate="metadata.filial.regtribmun.validator"></form-field> -->
          </div>
        </div>

        <div v-if="tabNf">
          <label-title class="mt-2" title="Informações Para Emissão de NF-e"></label-title>
          <div class="row">
            <form-field v-model="filial.tpambnfe" type="select" col="3" :metadata="metadata.filial.tpambnfe">
            </form-field>
            <!-- <form-field v-model="filial.tpimpnfe" type="select" col="3" :metadata="metadata.filial.tpimpnfe"></form-field> -->
            <form-field v-model="filial.contingencia" type="select" col="3" :metadata="metadata.filial.contingencia">
            </form-field>
          </div>
          <div class="row">
            <form-field v-model="filial.imun" type="number" col="3" :metadata="metadata.filial.imun" name="imun"
              :v-errors="errors" v-validate="metadata.filial.imun.validator"></form-field>
            <form-field v-model="filial.cnae" type="number" col="3" :metadata="metadata.filial.cnae" name="cnae"
              :v-errors="errors" v-validate="metadata.filial.cnae.validator"></form-field>
          </div>
          <div class="row">
            <form-field v-model="filial.autcnpj" type="cnpj" col="3" :metadata="metadata.filial.autcnpj"
              name="autcnpj" :v-errors="errors" v-validate="metadata.filial.autcnpj.validator"></form-field>
            <form-field v-model="filial.autcpf" type="number" col="3" :metadata="metadata.filial.autcpf" name="autcpf"
              :v-errors="errors" v-validate="metadata.filial.autcpf.validator"></form-field>
          </div>
          <div class="row">
            <form-field v-model="filial.cnpjcontador" type="cnpj" col="3" label="CNPJ do Contador"
              name="cnpjcontador" :v-errors="errors" v-validate="{max: 18}"></form-field>
          </div>
          <label-title class="mt-5" title="Informações Para Emissão de NF Consumidor"></label-title>
          <div class="row">
            <form-field v-model="filial.csc" type="text" col="6" :metadata="metadata.filial.csc" name="csc"
              :v-errors="errors" v-validate="metadata.filial.csc.validator" case="normal"></form-field>
            <form-field v-model="filial.idcsc" type="text" col="2" :metadata="metadata.filial.idcsc" name="idcsc"
              case="normal" :v-errors="errors" v-validate="metadata.filial.idcsc.validator"></form-field>
          </div>
          <div class="row">
            <!-- <form-field v-if="filial.crt!='1'" v-model="filial.regimepiscofins" type="select" col="3" :metadata="metadata.filial.regimepiscofins"
                        name="regimepiscofins" :v-errors="errors" v-validate="metadata.filial.regimepiscofins.validator"></form-field>
                    <form-field v-if="filial.crt!='1'" v-model="filial.dedicmpiscofins" type="select" col="3" :metadata="metadata.filial.dedicmpiscofins"
                        name="dedicmpiscofins" :v-errors="errors" v-validate="metadata.filial.dedicmpiscofins.validator"></form-field>  -->
            <form-field v-model="filial.apis" type="value" col="2" :metadata="metadata.filial.apis" :precision="2"
              v-if="filial.crt != '1' && filial.crt != '4'" name="apis" :v-errors="errors"
              v-validate="metadata.filial.apis.validator"></form-field>
            <form-field v-model="filial.acofins" type="value" col="2" :metadata="metadata.filial.acofins" :precision="2"
              v-if="filial.crt != '1' && filial.crt != '4'" name="acofins" :v-errors="errors"
              v-validate="metadata.filial.acofins.validator"></form-field>
          </div>

          <div class="w-100 mt-5"></div>
          <label-title title="Inscrições de Substituto Tributário"></label-title>
          <div class="row align-items-center" v-for="(iest, index) in listSubstitutos" :key="index">
            <div class="col-md-2 col-12">
              <form-field v-model="iest.uf" type="select" :metadata="metadata.iest.uf" :select-options="estadoList">
              </form-field>
            </div>
            <div class="col-md-3 col-10">
              <form-field v-model="iest.iest" type="text" :metadata="metadata.iest.iest" name="iest" :v-errors="errors"
                v-validate="metadata.iest.iest.validator"></form-field>
            </div>
            <div class="col-md-2 col-2">
              <v-button label="" title="Excluir Estado" icon="fa-trash" @click="handleDeleteUF(index)"></v-button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-12">
              <v-button label="Adicionar Estado" title="" :nb-btdef="true" @click="handleAdicionaUF"></v-button>
            </div>
          </div>
          <!-- <div class="mb-4">
            <label-title
              title="Dados Configurações do SAT"
              class="mb-2 mt-4"
            ></label-title>
            <div class="row">
              <div class="col-md-6 col-12">
                <v-label label="Assinatura (signAC)"></v-label>
                <form-field
                  key="signAC"
                  v-model="parametros.sat.signAC"
                  type="text"
                  case="normal"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Assinatura (signAC)"
                ></form-field>
              </div>
              <div class="col-md-6 col-12">
                <v-label label="Código de ativação SAT"></v-label>
                <form-field
                  ref="codigoDeAtivacao"
                  v-model="parametros.sat.codigoDeAtivacao"
                  type="text"
                  case="normal"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Codigo de ativacao SAT"
                ></form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-12">
                <v-label label="Caminho da DLL"></v-label>
                <form-field
                  ref="nomeDLL"
                  v-model="parametros.sat.nomeDLL"
                  type="text"
                  case="normal"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Caminho da DLL"
                  :validateDisabledKeys="false"
                ></form-field>
              </div>
              <div class="col-md-6 col-12">
                <v-label label="Arquivo de log"></v-label>
                <form-field
                  key="arqLOG"
                  v-model="parametros.sat.arqLOG"
                  type="text"
                  case="normal"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Arquivo de Log"
                  :validateDisabledKeys="false"
                ></form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-12">
                <input-checkbox
                  :estilo="'text-info'"
                  label="Sempre Visualizar Impressão antes de imprimir SAT"
                  v-model="parametros.sat.visualizarImp"
                  :value-checked="true"
                  :value-unchecked="false"
                ></input-checkbox>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-12">
                <input-checkbox
                  :estilo="'text-info'"
                  label="Utilizando emulador do SAT para teste"
                  v-model="parametros.sat.emulador"
                  :value-checked="true"
                  :value-unchecked="false"
                ></input-checkbox>
              </div>
            </div>
          </div> -->
        </div>

        <div v-if="tabPed" class="mb-4">
          <label-title title="Permissões"></label-title>
          <div class="row">
            <div class="col-md-12 col-12">
              <v-label label="Informe o % de rentabilidade para bloquear o pedido de venda"></v-label>
            </div>
            <div class="col-md-2 col-12">
              <form-field v-model="parametros.rentabilidade_minima" type="value" addon="%" :precision="2"
                data-toggle="tooltip" data-placement="top"
                title="Possibilita o bloqueio do pedido de venda pela rentabilidade mínima em relação ao custo informado no cadastro de produto.">
              </form-field>
            </div>
            <div class="col-md-12 col-12 mb-3">
              <input-checkbox :estilo="'text-info'" label="Controla estoque dos produtos?"
                v-model="parametros.controlaestoque" :value-checked="true" :value-unchecked="false"></input-checkbox>
            </div>
            <div class="col-md-12 col-12 pl-5 mb-3" v-if="parametros.controlaestoque">
              <input-checkbox :estilo="'text-info'" label="Bloquear venda sem estoque"
                v-model="parametros.venda_sem_estoque" :value-checked="true" :value-unchecked="false"></input-checkbox>
            </div>
            <div class="col-md-12 col-12 mb-3">
              <input-checkbox :estilo="'text-info'" label="Bloquear venda para clientes sem crédito"
                v-model="parametros.venda_sem_credito" :value-checked="true" :value-unchecked="false"></input-checkbox>
            </div>
            <div class="col-md-12 col-12 mb-3">
              <input-checkbox :estilo="'text-info'" label="Agrupar itens repetidos no pedido?"
                v-model="parametros.agrupar_itens_pedido" :value-checked="true" :value-unchecked="false">
              </input-checkbox>
            </div>
          </div>

          <div class="w-100 mt-3"></div>

          <label-title title="Pedido e Nota Fiscal"></label-title>
          <div class="row">
            <div class="col-md-12 col-12">
              <v-label label="Selecione uma forma de pagamento padrão das parcelas do pedido e nota Fiscal"></v-label>
            </div>
            <form-field ref="formapag" v-model="parametros.parcelas.formapag" type="select" col="3"
              :metadata="metadata.pedvpar.formapag"></form-field>
          </div>
          <div>
            <label-title title="Dados integração com sistema FF" class="mb-2 mt-2"></label-title>
            <div class="row">
              <div class="col-md-12 col-12">
                <input-checkbox :estilo="'text-info'" label="Exibir dados do estoque na digitação do pedido"
                  v-model="parametros.exibir_estoque_integracao" :value-checked="true" :value-unchecked="false">
                </input-checkbox>
              </div>
            </div>
          </div>

          <div class="w-100 mt-3"></div>

          <label-title title="Informações Gerais e Garantia dos produtos"></label-title>
          <div class="row text-editor">
            <div class="col-md-7 my-3">
              <wysiwyg v-model="parametros.pedido.observacao_garantia" />
            </div>
          </div>
        </div>
        <!-- Marketplaces -->
        <div v-if="tabEcommerce">
          <!-- Marketplaces B2W -->
          <label-title title="Dados Marketplace B2W" class="mb-2 mt-2"></label-title>
          <div class="row">
            <div class="col-md-4 col-12">
              <v-label label="Usuário-Email"></v-label>
              <form-field v-model="parametros.marketplaces.b2w.userlogin" type="text" case="normal"
                data-toggle="tooltip" data-placement="top" title="Usuário-Email para login no marketplace B2W.">
              </form-field>
            </div>
            <div class="col-md-4 col-12">
              <v-label label="Api-key"></v-label>
              <form-field v-model="parametros.marketplaces.b2w.apikey" type="text" case="normal" data-toggle="tooltip"
                data-placement="top" title="Api-key para acesso no marketplace B2W."></form-field>
            </div>
            <div class="col-md-4 col-12">
              <v-label label="Account Manager Key"></v-label>
              <form-field v-model="parametros.marketplaces.b2w.accountmanagerkey" type="text" case="normal"
                data-toggle="tooltip" data-placement="top" title="Account Manager Key para acesso no marketplace B2W.">
              </form-field>
            </div>
          </div>

          <!-- Marketplaces Mercado Livre -->
          <label-title title="Dados Marketplace Mercado Livre" class="mb-2 mt-2"></label-title>
          <div class="row">
            <div class="col-md-6 col-12">
              <v-button class="text-right" label="Requisitar Permissão Mercado Livre" icon="fa-id-card"
                @click="handlePermissaoMercadoLivre()"></v-button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-12">
              <v-label label="Code"></v-label>
              <form-field key="mlcode" v-model="parametros.marketplaces.mercadolivre.code" type="text" case="normal"
                data-toggle="tooltip" data-placement="top" title="Code para acesso no marketplace B2W."></form-field>
            </div>
            <div class="col-md-6 col-12">
              <v-label label="Access Token"></v-label>
              <form-field ref="mlaccesstoken" v-model="parametros.marketplaces.mercadolivre.accesstoken" type="text"
                case="normal" data-toggle="tooltip" data-placement="top"
                title="Access token para acesso no marketplace Mercado Livre."></form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-12">
              <v-label label="Refresh Token"></v-label>
              <form-field ref="mlrefreshtoken" v-model="parametros.marketplaces.mercadolivre.refreshtoken" type="text"
                case="normal" data-toggle="tooltip" data-placement="top"
                title="Refresh token para acesso no marketplace Mercado Livre."></form-field>
            </div>

            <div class="col-md-6 col-12">
              <v-label label="User ID"></v-label>
              <form-field ref="mluserid" v-model="parametros.marketplaces.mercadolivre.userid" type="text" case="normal"
                data-toggle="tooltip" data-placement="top" title="User ID para acesso no marketplace Mercado Livre.">
              </form-field>
            </div>
          </div>
        </div>

        <!-- Pagamento Online -->
        <!-- <div v-if="!showPagOnline" class="mt-2 mb-2">
                <a href="javascript:void(0);" @click="showPagOnline = true"><i class="fa fa-caret-down" aria-hidden="true"></i> Exibir dados Pagamentos Online</a>
            </div>
            <div v-if="showPagOnline">
                Cielo
                <label-title title="Dados Pagamentos Online Cielo" class="mb-2 mt-2"></label-title>
                <div class="row">
                    <div class="col-md-6 col-12">
                       <v-label label="Client Id"></v-label>
                       <form-field key="cieloclientid" v-model="parametros.pagonline.cielo.clientid" type="text" case="normal"
                        data-toggle="tooltip" data-placement="top" title="client Id para acesso ao Cielo API."></form-field>
                    </div>
                    <div class="col-md-6 col-12">
                       <v-label label="Client Secret"></v-label>
                       <form-field ref="cieloclientsecret" v-model="parametros.pagonline.cielo.clientsecret" type="text" case="normal"
                        data-toggle="tooltip" data-placement="top" title="Client Secret para acesso ao Cielo API."></form-field>
                    </div>
                </div>
                Rede
                <label-title title="Dados Pagamentos Online REDE" class="mb-2 mt-2"></label-title>
                <div class="row">
                    <div class="col-md-6 col-12">
                       <v-label label="Token"></v-label>
                       <form-field key="redetoken" v-model="parametros.pagonline.rede.token" type="text" case="normal"
                        data-toggle="tooltip" data-placement="top" title="token para acesso a REDE API."></form-field>
                    </div>
                    <div class="col-md-6 col-12">
                       <v-label label="PV"></v-label>
                       <form-field ref="redepv" v-model="parametros.pagonline.rede.pv" type="text" case="normal"
                        data-toggle="tooltip" data-placement="top" title="PV para acesso a REDE API."></form-field>
                    </div>
                </div>
            </div> -->

        <!-- SAT -->

        <!-- Integracao com sistema FF -->

        <!-- Parâmetros Venda Balcão -->

        <div id="tabFrente" v-if="tabFrente">
          <label-title title="Configurações de aparência do PDV" class="mb-2 mt-2"></label-title>
          <div class="row">
            <form-field v-model="parametros.pdv.colors.bg_top_bottom" type="color" col="3"
              label="Cor de Fundo Cabeçalho e Rodapé" name="bg_top_bottom" :v-errors="errors" v-validate="{}">
            </form-field>
            <form-field v-model="parametros.pdv.colors.fc_top_bottom" type="color" col="3"
              label="Cor de Fonte Cabeçalho e Rodapé" name="fc_top_bottom" :v-errors="errors" v-validate="{}">
            </form-field>
          </div>
          <div class="row">
            <form-field v-model="parametros.pdv.colors.bg_buttom" type="color" col="3" label="Cor de fundo dos botões"
              name="bg_buttom" :v-errors="errors" v-validate="{}"></form-field>
            <form-field v-model="parametros.pdv.colors.fc_buttom" type="color" col="3" label="Cor da fonte dos botões"
              name="fc_buttom" :v-errors="errors" v-validate="{}"></form-field>
          </div>
          <div class="row">
            <div class="col-md-3 col-6">
              <form-field v-model="parametros.pdv.default_header_title" type="text"
                :metadata="{ help: 'Informe o texto para exibição no topo da tela do PDV' }"
                label="Mensagem tela do PDV">
              </form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 col-6">
              <form-field v-model="parametros.pdv.formato_venda_manual" type="select" label="Informar Qtd e Preço?"
                :select-options="nao_sim_options" name="formato_venda_manual"></form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 col-6">
              <form-field v-model="parametros.pdv.exibe_opcao_gerar_nfce" type="select"
                label="Permite gerar NFC-e pelo PDV" :select-options="nao_sim_options"></form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 col-6">
              <form-field v-model="parametros.pdv.ir_para_emissao_nf" type="select"
                label="Em caso de rejeição da (Nfe/Nfce)" :select-options="pdv_ir_para_emissao_nf_options"
                :metadata="{ help: 'Definao o que fazer quando a NF for rejeitada' }"></form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 col-6">
              <form-field v-model="parametros.pdv.default_focus_btn_pag" type="select"
                label="Ação Padrão Após Pagamento" :select-options="focus_btn_pag_options"></form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 col-6">
              <form-field v-model="parametros.pdv.observacao" type="text" case="normal" label="Observações"
                data-toggle="tooltip" data-placement="top"
                :metadata="{ help: 'Observações para impressão do cupom não fiscal' }"></form-field>
            </div>
          </div>
          <label-title title="Controle do Estoque" class="mb-2 mt-5"></label-title>
          <div class="row m-2">
            <div class="col-md-4 col-6">
              <input-checkbox :estilo="'text-info'" label="Baixa estoque dos produtos?"
                v-model="parametros.controlaestoque" :value-checked="true" :value-unchecked="false"></input-checkbox>
              <!-- <form-field
                v-model="parametros.pdv.mov_estoque_conclu_venda"
                type="select"
                label="Movimentar estoque na conclusão do pedido"
                :select-options="nao_sim_options"
                name="mov_estoque_conclu_venda"
              ></form-field> -->
            </div>
          </div>

          <label-title title="Preços" class="mb-2 mt-5"></label-title>
          <div class="row">
            <div class="col-md-3 col-6">
              <form-field v-model="parametros.pdv.tabela_preco" type="select" label="Tabela de preço do PDV"
                :select-options="tabelas_preco_options"></form-field>
            </div>
          </div>

          <div class="row" v-if="parametros.pdv.tabela_preco">
            <div class="col-md-3 col-6">
              <form-field v-model="parametros.pdv.altera_preco" type="select" label="Permite alterar o preço de venda"
                :select-options="nao_sim_options"></form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3 col-6">
              <form-field v-model="parametros.pdv.permite_desconto" type="select" label="Permite desconto na venda?"
                :select-options="nao_sim_options"></form-field>
            </div>
            <div class="col-md-2 col-6" v-if="parametros.pdv.permite_desconto == 'S'">
              <form-field v-model="parametros.pdv.desconto_max" type="value" addon="%" :precision="2"
                label="Desconto máximo" data-toggle="tooltip" data-placement="top"
                title="Desconto máximo que o vendedor pode aplicar em uma venda."></form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3 col-6">
              <form-field v-model="parametros.pdv.permite_acrescimo" type="select" label="Permite acrescimo na venda?"
                :select-options="nao_sim_options"></form-field>
            </div>
            <div class="col-md-2 col-6" v-if="parametros.pdv.permite_acrescimo == 'S'">
              <form-field v-model="parametros.pdv.acrescimo_max" type="value" addon="%" :precision="2"
                label="Acréscimo máximo" data-toggle="tooltip" data-placement="top"
                title="Acréscimo máximo que o vendedor pode aplicar em uma venda."></form-field>
            </div>
          </div>

          <!-- <div class="row">
            <div class="col-md-3 col-6">
              <form-field
                v-model="parametros.pdv.parcelas_somente_dias_uteis"
                type="select"
                label="Parcelas somente dias úteis"
                :select-options="nao_sim_options"
              ></form-field>
            </div>
          </div> -->

          <!-- <div class="row">
            <div class="col-md-3 col-6">
              <form-field
                v-model="parametros.pdv.exibe_opcao_gerar_sat"
                type="select"
                label="Permite gerar SAT pelo PDV"
                :select-options="nao_sim_options"
              ></form-field>
            </div>
          </div> -->

          <label-title title="Controle de Comandas e Mesas" class="mb-2 mt-5"></label-title>
          <div class="row">
            <div class="col-md-3 col-6">
              <form-field v-model="parametros.pdv.tipo_controle_cm_ms" type="select" placeholder="Não"
                label="Controle Comanda / Mesa" :select-options="tipo_controle_cm_ms_options"></form-field>
            </div>
          </div>
          <div v-if="
            parametros.pdv.tipo_controle_cm_ms == 'MC' ||
            parametros.pdv.tipo_controle_cm_ms == 'MS'
          " class="mb-4">
            <label-title title="Adicionar uma mesa"></label-title>
            <div class="row align-items-center" v-for="(mesa, index) in parametros.pdv.listMesas" :key="index">
              <div class="col-md-2 col-12">
                <form-field type="text" label="Código" v-model="mesa.id"></form-field>
              </div>
              <div class="col-md-2 col-12">
                <form-field type="text" label="Descrição" v-model="mesa.descricao"></form-field>
              </div>
              <div class="col-md-2 col-12">
                <form-field type="text" label="Observação" v-model="mesa.obs"></form-field>
              </div>
              <div class="col-md-2 col-2">
                <v-button label="" title="Excluir Mesa" icon="fa-trash" @click="handleDeleteMesa(index)"></v-button>
              </div>
            </div>
            <div class="row mb-5">
              <div class="col-md-12 col-12">
                <v-button label="Adicionar Mesa" :nb-btdef="true" @click="handleAdicionarMesa()"></v-button>
              </div>
            </div>
            <!-- <div class="col-md-3 col-6">
                        <form-field v-model="parametros.pdv.tipo_controle_cm_ms" type="select" label="Controle Comanda / Mesa"
                        :select-options="tipo_controle_cm_ms_options"></form-field>
                    </div> -->
          </div>

          <label-title title="Configuração para leitura de balanças" class="mb-2 mt-5"></label-title>
          <div class="row">
            <div class="col-12">
              <warnings :messages="['Configure aqui as posições para leitura de código de barras de balanças!']">
              </warnings>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-12">
              <form-field v-model="parametros.pdv.balanca.tamanhobarra" type="value" :precision="0"
                label="Tamanho total do código de barras da balança" data-toggle="tooltip" data-placement="top">
              </form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-12">
              <form-field v-model="parametros.pdv.balanca.numero_identificacao" type="value" :precision="0"
                label="Identificar do código de barras da balança" data-toggle="tooltip" data-placement="top">
              </form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-12">
              <form-field v-model="parametros.pdv.balanca.inicio_codigo" type="value" :precision="0"
                label="Posição inicial do código do produto" data-toggle="tooltip" data-placement="top"></form-field>
            </div>
            <div class="col-md-4 col-12">
              <form-field v-model="parametros.pdv.balanca.fim_codigo" type="value" :precision="0"
                label="Posição final do código do produto" data-toggle="tooltip" data-placement="top"></form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-12">
              <form-field v-model="parametros.pdv.balanca.barras_peso_ou_valor" type="select"
                label="O código de barras contém o peso ou o valor?" :select-options="pdv_balanca_peso_valor_options">
              </form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-12">
              <form-field v-model="parametros.pdv.balanca.inicio_valor" type="value" :precision="0"
                label="Posição inicial do Peso ou Valor" data-toggle="tooltip" data-placement="top"></form-field>
            </div>
            <div class="col-md-4 col-12">
              <form-field v-model="parametros.pdv.balanca.fim_valor" type="value" :precision="0"
                label="Posição final do Peso ou Valor" data-toggle="tooltip" data-placement="top"></form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-12">
              <form-field v-model="parametros.pdv.balanca.qtd_casas_valor" type="select"
                label="Quantidade de dígitos de casas decimais do valor" :select-options="pdv_qtd_casas_valor_options">
              </form-field>
            </div>
          </div>
        </div>

        <!-- Siscomex / Duimp -->
        <div v-if="tabDuimp">
          <label-title title="Integração Siscomex / Duimp" class="mb-2 mt-2"></label-title>
          <div class="row">
            <div class="col-md-4 col-12">
              <v-label label="Ambiente Siscomex"></v-label>
              <form-field v-model="filial.siscomex_environment" type="select"
                :select-options="siscomex_env_options" name="siscomex_environment">
              </form-field>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-6 col-12">
              <v-label label="Client ID"></v-label>
              <form-field v-model="filial.siscomex_clientid" type="text" case="normal"
                data-toggle="tooltip" data-placement="top" title="Client ID obtido no Portal Único Siscomex.">
              </form-field>
            </div>
            <div class="col-md-6 col-12">
              <v-label label="Client Secret"></v-label>
              <form-field v-model="filial.siscomex_clientsecret" type="password" case="normal"
                data-toggle="tooltip" data-placement="top" title="Client Secret obtido no Portal Único Siscomex.">
              </form-field>
            </div>
          </div>
        </div>

        <div v-if="tabEtiqueta">
          <label-title title="Configuração Layout de Etiquetas" class="mb-2 mt-2"></label-title>
          <div class="row" v-for="(etiqueta, index) in listEtiquetas" :key="index">
            <div class="col-12 d-flex align-items-center mt-3">
              <form-field v-model="etiqueta.descricao" type="text" col="3" label="Descrição Etiqueta"></form-field>
              <form-field v-model="etiqueta.tipo" type="select" col="3" label="Tipo"
                :select-options="etiquetaTipoOptions"></form-field>
              <div class="mt-2">
                <v-button label="" title="Configurar Etiqueta" icon="fa-cog" @click="handleSetEtiqueta(etiqueta)">
                </v-button>
                <v-button label="" title="Deletar Etiqueta" icon="fa-trash" @click="handleDeleteEtiqueta(index)">
                </v-button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <v-button label="Nova Etiqueta" title="Adicionar Nova Etiqueta" icon="fa-plus" :nb-btdef="true"
                @click="handleAdicionaEtiqueta"></v-button>
            </div>
          </div>

          <!-- Modal Add Etiqueta -->
          <div class="nb-modal-scrollable" v-if="showModalEtiqueta">
            <div class="container nb-modal-scrollable-container nb-email-container">
              <div class="nb-modal-header">
                <h5>Criar Nova Etiqueta</h5>
                <button type="button" class="close" @click="handleCloseModal()" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="nb-modal-scrollable-body">
                <div class="row">
                  <div class="col-12">
                    <layout-etiqueta ref="etiqueta" :dados-etiqueta="this.etiqueta"></layout-etiqueta>
                  </div>
                </div>
                <div class="nb-modal-scrollable-footer">
                  <v-button ref="btnConfirm" label="Salvar" title="" :nb-btdef="true" @click="handleSaveEtiqueta">
                  </v-button>
                  <v-button ref="btnClose" label="Cancelar" title="" @click="handleCloseModal()"></v-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- financeiro -->
        <div v-if="tabFinanceiro">
          <div>
            <h5 class="mx-3">Carta de Cobrança</h5>
            <div>
              <form-field ref="nome" v-model="parametros.cartaCobranca.emailResposta" label="Email de Resposta"
                type="email" col="7" name="email"></form-field>
            </div>
            <div>
              <form-field ref="nome" v-model="parametros.cartaCobranca.assunto" label="Assunto" type="text" col="7"
                name="assunto"></form-field>
            </div>
            <div class="row text-editor">
              <div class="col-md-7 my-3">
                <wysiwyg v-model="parametros.cartaCobranca.textoEmail" />
              </div>
            </div>
          </div>
        </div>

        <!-- Tab Certificado -->
        <div v-if="tabCertificado">
          <app-certificado :codfil="filial.codfil" :disableBtnVoltar="true"></app-certificado>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SysVars } from "../main";
import axios from "axios";
import { apiConsultaCadastro, apiORDSpost, apiORDSapp, apiORDSmidia, } from "../shared/api-functions";
import { cidades } from "../shared/nfse";
import LayoutEtiqueta from "../components/layout-etiqueta.vue";
import AppCertificado from "./app-certificado";
import Tourguide from "tourguidejs";

export default {
  props: {
    index: "",
    crud: "",
    list: "",
    guide: Boolean,
    type: ""
  },

  data() {
    return {
      tabs: [
        // {title: 'Dados Gerais', icon:'fa-building'},
        // {title: 'Pedido', icon:'fa-shopping-basket'},
        // {title: 'NF-e e NFC-e', icon:'fa-file-invoice-dollar'},
        // {title: 'Frente de Caixa', icon:'fa-cash-register'},
        // {title: 'Integração Ecommerce', icon:'fa-at'}
        { title: "Dados Gerais", icon: "" },
        { title: "NF-e e NFC-e", icon: "" },
        { title: "Certificado Digital", icon: "" },
        { title: "Pedidos de Venda", icon: "" },
        { title: "Frente de Caixa", icon: "" },
        { title: "Financeiro", icon: "" },
        { title: "Ecommerce", icon: "" },
        { title: "Siscomex / Duimp", icon: "" },
        { title: "Etiquetas", icon: "" },
      ],
      crudText: "",
      codfil: null,
      filial: { ...this.$store.getters.getEntities.filial },
      listSubstitutos: [],
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: [], //armazena as mensagens de validacao do servidor para mostrar em tela
      estadoList: [],
      tipo_ie: "COM_IE",
      tipo_ie_options: [
        { id: "COM_IE", text: "Possui Inscrição Estadual" },
        { id: "ISENTO", text: "Empresa Isenta de Inscrição Estadual" },
        { id: "SEM_IE", text: "Contribuinte Exclusivo IBS/CBS (Sem Inscrição Estadual)" }
      ],
      activeTab: 0,

      disableRetorno: false,
      showMarketplaces: false,
      showPagOnline: false,
      showIntFF: false,
      showSAT: false,
      showPDV: false,
      showModalEtiqueta: false,
      showFormCert: false, //exibe a tela de manutencao do certificado

      nfse_login: false,
      nfse_senha: false,
      nfse_token: false,
      nfse_certificado: false,

      ML_APP_ID: "1536197050949661",
      ML_SECRET_KEY: "THWeVgitHbvAH0iIZqMJkpZA10gPbyaS",

      parametros: {
        controlaestoque: false,
        venda_sem_estoque: false,
        venda_sem_credito: true,
        agrupar_itens_pedido: false,
        rentabilidade_minima: null,
        exibir_estoque_integracao: false,
        marketplaces: {
          b2w: {
            userlogin: null,
            apikey: null,
            accountmanagerkey: null
          },
          mercadolivre: {
            code: null,
            accesstoken: null,
            refreshtoken: null,
            userid: null
          }
        },
        pagonline: {
          cielo: {
            clientid: null,
            clientsecret: null
          },
          cielo: {
            token: null,
            pv: null
          }
        },
        sat: {
          signAC: null,
          codigoDeAtivacao: null,
          nomeDLL: null,
          arqLOG: null,
          visualizarImp: null,
          emulador: null
        },
        parcelas: {
          formapag: null
        },
        etiquetas: [],
        pedido: {
          observacao_garantia: null
        },
        nfse: {
          login: null,
          senha: null,
          token: null,
          nfseNacional: null
        }
      },

      image: null,
      selectedFile: "",
      etiqueta: null,
      listEtiquetas: [],
      etiquetaTipoOptions: [{ id: "P", text: "Produto" }],
      bodyContent: null,

      steps: [
        {
          selector: "",
          step: 1,
          title: `Vamos começar!`,
          content:
            "Vamos te guiar passo a passo por todo o processo de cadastro da empresa.</br></br><a href='javascript:void(0)' class='btn btn-sm btn-danger text-white' onclick='window.dispatchEvent(new CustomEvent(\"desativar-guia\"))'>Não mostrar este guia</a>"
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          selector: "#cnpj",
          step: 2,
          title: `Cnpj`,
          content: "Informe o CNPJ da empresa."
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          selector: "#nome",
          step: 3,
          title: `Nome`,
          content: "Informe o Nome/Razão Social da empresa."
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          selector: "#fantasia",
          step: 4,
          title: `Fantasia`,
          content: "Informe o Nome Fantasia da empresa."
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          selector: "#isento",
          step: 5,
          title: `Isento de Inscrição Estadual?`,
          content: "Informe se a empresa é isenta de inscrição estadual."
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          selector: "#crt",
          step: 6,
          title: `Regime Tributário`,
          content: "Informe o Regime Tributário da empresa."
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          selector: "#cep",
          step: 7,
          title: `CEP do Endereço`,
          content: "Informe o CEP do endereço da empresa."
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          selector: "#endenr",
          step: 8,
          title: `Numero do Endereço`,
          content: "Informe o Nr. do endereço da empresa."
          // "image": "https://somehost.com/image.jpeg"
        }
      ]
    };
  },

  computed: {
    showPreencherCadastro: function () {
      return (
        this.filial.cnpj &&
        this.filial.cnpj.length == 14
      )
    },
    typeNfe() {
      return type === "NFE" && guide === true;
    },
    typePDV() {
      return type === "PDV" && guide === true;
    },
    typePedido() {
      return type === "PEDIDO";
    },

    filteredTabs() {
      if (!this.guide) {
        return this.tabs;
      }

      if (this.type === "NFE") {
        return [
          { title: "Dados Gerais", icon: "" },
          { title: "NF-e e NFC-e", icon: "" },
          { title: "Certificado Digital", icon: "" },
          // { title: "Frente de Caixa", icon: "" },
          // { title: "Integração Ecommerce", icon: "" },
          // { title: "Etiquetas", icon: "" },
          // { title: "Financeiro", icon: "" }
        ];
      }

      if (this.type === "PDV") {
        return [
          // { title: "Dados Gerais", icon: "" },
          { title: "Frente de Caixa", icon: "" },
          { title: "NF-e e NFC-e", icon: "" },
          { title: "Certificado Digital", icon: "" },
        ];
      }

      if (this.type === "PEDIDO") {
        return [
          { title: "Dados Gerais", icon: "" },
          { title: "Pedidos de Venda", icon: "" }
        ];
      }

      return this.tabs;
    },
    tabLength() {
      return this.filteredTabs.length;
    },
    tabCertificado() {
      return this.getTabIndex("Certificado Digital") === this.activeTab;
    },
    tabDados() {
      return this.getTabIndex("Dados Gerais") === this.activeTab;
    },
    tabPed() {
      return this.getTabIndex("Pedidos de Venda") === this.activeTab;
    },
    tabNf() {
      return this.getTabIndex("NF-e e NFC-e") === this.activeTab;
    },
    tabFrente() {
      return this.getTabIndex("Frente de Caixa") === this.activeTab;
    },
    tabEcommerce() {
      return this.getTabIndex("Ecommerce") === this.activeTab;
    },
    tabDuimp() {
      return this.getTabIndex("Siscomex / Duimp") === this.activeTab;
    },
    tabEtiqueta() {
      return this.getTabIndex("Etiquetas") === this.activeTab;
    },
    tabFinanceiro() {
      return this.getTabIndex("Financeiro") === this.activeTab;
    },
    tokenEmpresa: function () {
      return this.$store.getters.getSessao.empresa;
    },
    appForcaVendas: function () {
      return SysVars.appForcaVendas;
    },
    appNFe: function () {
      return SysVars.appNFe;
    },
    titleForm: function () {
      return "Dados da Empresa";
    },
    activeTabTitle() {
      return this.filteredTabs && this.filteredTabs.length > this.activeTab
        ? this.filteredTabs[this.activeTab].title
        : "";
    },

    tipo_controle_cm_ms_options: function () {
      let options = [];

      options.push({ id: "CM", text: "Comanda" });
      options.push({ id: "MS", text: "Mesa" });
      options.push({ id: "MC", text: "Mesa e Comanda" });

      return options;
    },
    focus_btn_pag_options: function () {
      let options = [];

      options.push({ id: "CP", text: "Imprimir Cupom" });
      options.push({ id: "ES", text: "Emitir SAT" });
      options.push({ id: "NC", text: "Emitir NFC-e" });
      options.push({ id: "NF", text: "Emitir NF" });
      options.push({ id: "FV", text: "Finalizar Venda" });

      return options;
    },
    pdv_ir_para_emissao_nf_options: function () {
      let options = [];

      options.push({ id: "NF", text: "Ir Para Tela de Emissão de Notas" });
      options.push({ id: "NV", text: "Ir Para Nova Venda" });

      return options;
    },
    nao_sim_options: function () {
      //monta objeto de tabelas de preco conforme permissao do usuario (usuario.parametros.vendas.tabelaspreco)
      let options = [];

      options.push({ id: "N", text: "Não" });
      options.push({ id: "S", text: "Sim" });

      return options;
    },

    pdv_tipo_desc_acre_options: function () {
      //monta objeto de tabelas de preco conforme permissao do usuario (usuario.parametros.vendas.tabelaspreco)
      let options = [];

      options.push({ id: "V", text: "Valor" });
      options.push({ id: "P", text: "Porcentagem" });
      options.push({ id: "A", text: "Ambos" });

      return options;
    },

    tabelas_preco_options: function () {
      //monta objeto de tabelas de preco conforme permissao do usuario (usuario.parametros.vendas.tabelaspreco)
      let options = [];

      let liberado = [];
      let currTabpre = {};

      for (var x = 0; x < this.$store.getters.getTabpreList.length; x++) {
        currTabpre = this.$store.getters.getTabpreList[x];

        //se existir parametros do usuario, libera somente as tabelas permitidas
        if (
          this.$store.getters.getParametrosUsuario &&
          this.$store.getters.getParametrosUsuario.vendas
        ) {
          liberado = this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.filter(
            obj => {
              return obj == currTabpre.codtabpre;
            }
          );
          if (liberado.length > 0) {
            options.push({
              id: currTabpre.codtabpre,
              text: currTabpre.descricao
            });
          }
        } else {
          options.push({
            id: currTabpre.codtabpre,
            text: currTabpre.descricao
          });
        }
      }
      return options;
    },

    pdv_balanca_peso_valor_options: function () {
      //monta objeto de tabelas de preco conforme permissao do usuario (usuario.parametros.vendas.tabelaspreco)
      let options = [];

      options.push({ id: "P", text: "Peso" });
      options.push({ id: "V", text: "Valor" });

      return options;
    },

    pdv_qtd_casas_valor_options: function () {
      //monta objeto de tabelas de preco conforme permissao do usuario (usuario.parametros.vendas.tabelaspreco)
      let options = [];

      options.push({ id: 2, text: "2" });
      options.push({ id: 3, text: "3" });
      options.push({ id: 4, text: "4" });

      return options;
    },

    siscomex_env_options: function () {
      let options = [];
      options.push({ id: "H", text: "Homologação" });
      options.push({ id: "P", text: "Produção" });
      return options;
    },

    showGuia: function () {
      return SysVars.guia;
    }
  },

  methods: {
    handlePreencherCadastro() {
      if (!this.filial.cnpj) {
        this.$erpToastError("Preencha o CNPJ");
        return;
      }
      apiConsultaCadastro(
        this,
        this.filial.cnpj,
        this.filial.uf,
        this.updateDadosCadastrais
      );
    },
    updateDadosCadastrais(dados) {
      this.filial.nome = (dados.nome || '').substr(0, 100);
      this.filial.fantasia = (dados.fantasia || dados.nome || '').substr(0, 100);
      this.filial.cnae = dados.cnae;
      this.filial.iest = dados.ie;
      this.filial.cep = dados.cep;
      this.filial.ende = (dados.endereco || '').substr(0, 100);
      this.filial.endenr = dados.nr;
      this.filial.endecomp = dados.complemento;
      this.filial.uf = dados.uf;
      this.filial.mun = dados.mun;
      this.filial.codmun = dados.cMun;
      this.filial.bairro = dados.bairro;
    },
    getTabIndex(title) {
      return this.filteredTabs.findIndex(tab => tab.title === title);
    },
    closeFormCertificado() {
      this.showFormCert = false;
      this.$scrollTo(0);
      this.loadData();
    },
    handleGuiaInstalacaoCertificado() {
      //EXIBE O GUIA DE INSTALACAO DO CERTIFICADO DIGITAL
      this.showFormCert = true;
    },
    handleAdicionarMesa() {
      //adiciona nova linha na lista de mesa
      this.parametros.pdv.listMesas.push({});
    },
    handleDeleteMesa(index) {
      this.parametros.pdv.listMesas.splice(index, 1);
    },
    handleCloseModal() {
      //Cancela alterações do modal
      this.$refs.etiqueta.items_backup.map((e, i) => {
        this.$refs.etiqueta.items[i] = {
          ...this.$refs.etiqueta.items_backup[i]
        };
      });
      this.showModalEtiqueta = false;
    },
    changeTab(idx) {
      this.activeTab = idx;
    },
    responseTokenMercadoLivre(data) {
      this.parametros.marketplaces.mercadolivre.accesstoken = data.access_token;
      this.mlaccesstoken = this.parametros.marketplaces.mercadolivre.accesstoken;
      this.parametros.marketplaces.mercadolivre.refreshtoken =
        data.refresh_token;
      this.mlrefreshtoken = this.parametros.marketplaces.mercadolivre.refreshtoken;
      this.parametros.marketplaces.mercadolivre.userid = data.user_id;
      this.mluserid = this.parametros.marketplaces.mercadolivre.userid;
    },
    requestTokenMercadoLivre(data) {
      var url =
        "https://api.mercadolibre.com/oauth/token?grant_type=authorization_code&client_id=" +
        this.ML_APP_ID +
        "&client_secret=" +
        this.ML_SECRET_KEY +
        "&code=" +
        this.parametros.marketplaces.mercadolivre.code;
      if (window.location.href.includes("notabrasil.com.br/teste/")) {
        url +=
          "&redirect_uri=" +
          window.location.origin +
          "/teste/mercadolivre_code.html";
      } else {
        url +=
          "&redirect_uri=" + window.location.origin + "/mercadolivre_code.html";
      }

      jQuery.post(url, this.responseTokenMercadoLivre);
    },
    getCodeFormPermissaoMercadoLivre() {
      const queryString = this.popup.location.search;

      const urlParams = new URLSearchParams(queryString);

      this.parametros.marketplaces.mercadolivre.code = urlParams.get("code");
      this.mlcode = this.parametros.marketplaces.mercadolivre.code;
      if (this.parametros.marketplaces.mercadolivre.code) {
        this.popup.close();
        this.requestTokenMercadoLivre();
      } else {
        this.onLoadFormPermissaoMercadoLivre();
      }
    },

    onLoadFormPermissaoMercadoLivre() {
      setTimeout(this.getCodeFormPermissaoMercadoLivre, 2000);
    },

    handlePermissaoMercadoLivre() {
      var url =
        "http://auth.mercadolivre.com.br/authorization?response_type=code&client_id=" +
        this.ML_APP_ID;
      //if (window.location.href.includes('notabrasil.com.br/teste/')){
      //    url += "&redirect_uri="+ window.location.origin +"/teste/#/mercadolivre/code";
      //}else{
      //    url += "&redirect_uri="+ window.location.origin +"/#/mercadolivre/code";
      //}

      this.popup = window.open(url, "myWindow", "width=800,height=600");

      this.popup.onload = this.onLoadFormPermissaoMercadoLivre;
    },

    closeForm() {
      if (this.$route.name == "empresa") {
        this.$router.go(-1);
      } else if (!this.disableRetorno) this.$emit("closeform");
    },

    updateCep() {
      //CARREGA INFORMACOES DO CEP
      this.filial.ende = SysVars.endereco.logradouro;
      this.filial.bairro = SysVars.endereco.bairro;
      this.filial.codmun = SysVars.endereco.ibge;
      this.filial.uf = SysVars.endereco.uf;
    },

    handleSave(guideDisableValidation) {
      //BOTAO SALVAR
      this.errmessages = [];

      console.log(guideDisableValidation)

      if (guideDisableValidation) {
        this.apiPost()
        return
      }

      //novo plano permite habilitar ambiente produção para emissão de 5 notas
      // if (SysVars.appTrial && this.filial.tpambnfe == '1')
      //     this.errmessages.push('Não é permitido emitir notas fiscais em "ambiente de produção" para contas em período de testes!')

      if (
        (this.filial.crt == "1" || this.filial.crt == "4") &&
        (this.filial.pcredsn || 0) <= 0
      )
        this.errmessages.push("% Aproveitamento Crédito deve ser preenchido.");


      if (this.errmessages.length > 0) {
        this.$validator.validateAll();
        this.$erpToastError(
          "Por favor, corrija os campos em destaque para continuar"
        );
        return;
      }

      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.$erpToastError(
            "Por favor, corrija os campos em destaque para continuar"
          );
        } else {
          // if ((this.filial.crt=='1') && ((this.filial.pcredsn||0)<=0)){
          //     this.$erpToastError('% Aproveitamento Crédito deve ser preenchido.')
          // }else{
          // this.apiPost()
          // }
          this.apiPost()
        }
      });
    },

    handleDelete() {
      //BOTAO Excluir
      this.apiDelete();
    },

    handleAdicionaUF() {
      //adiciona nova linha na lista de inscricoes de substituto tributario
      var iest = { ...this.$store.getters.getEntities.listSubstitutos };
      this.listSubstitutos.push(iest);
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip();
      });
    },

    handleDeleteUF(index) {
      //exclui uma inscricao de substituto tributario
      this.listSubstitutos.splice(index, 1);
    },

    handleAdicionaEtiqueta() {
      //adiciona novo campo para inserção de uma nova etiqueta
      var etiqueta = { descricao: null, conteudo: null, tipo: null };
      this.listEtiquetas.push(etiqueta);
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip();
      });
    },

    handleSetEtiqueta(etiqueta) {
      this.showModalEtiqueta = true;
      this.etiqueta = etiqueta;
    },

    handleSaveEtiqueta() {
      let conteudoEtiqueta = this.$refs.etiqueta.saveLayout();
      this.etiqueta.conteudo = conteudoEtiqueta;
      this.showModalEtiqueta = false;
    },

    handleDeleteEtiqueta(index) {
      //exclui uma inscricao de substituto tributario
      this.etiqueta = null;
      this.listEtiquetas.splice(index, 1);
    },

    loadListaEtiquetas() {
      return this.listEtiquetas;
    },

    async loadData() {
      //carrega lista de estados cadastrados
      await this.$store.dispatch("loadTabpre", {});
      await this.$store.dispatch("loadEstadoRegras");
      if (this.$store.getters.getEstadoList) {
        this.estadoList = this.$store.getters.getEstadoList.map(function (obj) {
          return { id: obj.uf, text: obj.uf };
        });
      }

      //carrega o registro para alteracao ou visualizacao

      if (this.crud == SysVars.crudI) {
        if (this.$store.getters.getFilialList.length == 0) {
          await this.$store.dispatch("loadSessao", this);
          this.filial.nome = this.$store.getters.getSessao.empresa_nome;
          this.filial.cnpj = this.$store.getters.getSessao.cnpj;
        }
        this.$set(this.filial, "cnpjcontador", "");
        this.filial.stfilial = "A";
        this.filial.uf = "SP";
        this.filial.crt = "1";
        this.filial.contingencia = "D";
        this.filial.tpambnfe = "2";
        this.filial.tpimpnfe = "1";
        this.filial.regimepiscofins = "1";
        this.isento = "N";
        this.disableRetorno = this.appForcaVendas;
        return;
      } else {
        if (this.index) this.codfil = this.index;
        else {
          let filialList = this.$store.getters.getFilialList;
          if (filialList.length > 0) {
            this.codfil = filialList[0].codfil;
          }
        }
      }
      // this.disableRetorno = false
      // if (this.$store.getters.getFilialList.length == 1) {
      //     this.disableRetorno = this.appForcaVendas
      // }
      await this.$store.dispatch("loadFilial", { id: this.codfil });
      if (this.$store.getters.getFilial) {
        this.filial = { ...this.$store.getters.getFilial };
        this.$set(this.filial, "cnpjcontador", this.filial.cnpjcontador || "");

        this.listSubstitutos = this.filial.list_iest; //lista de inscricoes ST

        if (this.filial.list_iest.length) {
          for (var x = 0; x < this.filial.list_iest; x++) {
            this.listSubstitutos.push(this.filial.list_iest[x]);
          }
        }

        if (this.filial.iest === "ISENTO") {
          this.tipo_ie = "ISENTO";
        } else if (!this.filial.iest || String(this.filial.iest).trim() === "") {
          this.tipo_ie = "SEM_IE";
          this.filial.iest = null;
        } else {
          this.tipo_ie = "COM_IE";
        }
        if (this.filial.parametros) {
          this.parametros = JSON.parse(this.filial.parametros);
        } else {
          this.parametros = {
            controlaestoque: false,
            venda_sem_estoque: false,
            venda_sem_credito: true,
            agrupar_itens_pedido: false,
            rentabilidade_minima: null
          };
        }

        if (this.parametros.hasOwnProperty("agrupar_itens_pedido") == false) {
          this.parametros.agrupar_itens_pedido = false;
        }

        if (this.parametros.hasOwnProperty("marketplaces") == false) {
          this.parametros.marketplaces = {
            b2w: {
              userlogin: null,
              apikey: null,
              accountmanagerkey: null
            },
            mercadolivre: {
              code: null,
              accesstoken: null,
              refreshtoken: null,
              userid: null
            }
          };
        }
        if (this.parametros.hasOwnProperty("pagonline") == false) {
          this.parametros.pagonline = {
            cielo: {
              clientid: null,
              clientsecret: null
            },
            rede: {
              token: null,
              pv: null
            }
          };
        }
        if (this.parametros.pagonline.hasOwnProperty("cielo") == false) {
          this.parametros.pagonline.cielo = {
            clientid: null,
            clientsecret: null
          };
        }
        if (this.parametros.pagonline.hasOwnProperty("rede") == false) {
          this.parametros.pagonline.rede = {
            token: null,
            pv: null
          };
        }

        if (this.parametros.hasOwnProperty("sat") == false) {
          this.parametros.sat = {
            signAC: null,
            codigoDeAtivacao: null,
            nomeDLL: null,
            arqLOG: null,
            visualizarImp: null,
            emulador: null
          };
        }

        if (this.parametros.hasOwnProperty("pdv") == false) {
          this.parametros.pdv = { ...this.$store.getters.getParamPDV }
        }

        if (
          this.parametros.hasOwnProperty("exibir_estoque_integracao") == false
        ) {
          this.parametros.exibir_estoque_integracao = false;
        }

        if (this.parametros.hasOwnProperty("parcelas") == false) {
          this.parametros.parcelas = {
            formapag: null
          };
        }

        if (
          this.parametros.pdv.hasOwnProperty("default_focus_btn_pag") == false
        ) {
          this.parametros.pdv.default_focus_btn_pag = null;
        }
        if (this.parametros.pdv.hasOwnProperty("ir_para_emissao_nf") == false) {
          this.parametros.pdv.ir_para_emissao_nf = null;
        }
        if (
          this.parametros.pdv.hasOwnProperty("tipo_controle_cm_ms") == false
        ) {
          this.parametros.pdv.tipo_controle_cm_ms = null;
        }
        if (this.parametros.pdv.hasOwnProperty("colors") == false) {
          this.parametros.pdv.colors = {
            bg_top_bottom: null,
            fc_top_bottom: null,
            bg_buttom: null,
            fc_buttom: null
          };
        }
        if (this.parametros.pdv.hasOwnProperty("listMesas") == false) {
          this.parametros.pdv.listMesas = [];
        }

        if (this.parametros.hasOwnProperty("etiquetas")) {
          this.listEtiquetas = this.parametros.etiquetas;
        }

        if (this.parametros.hasOwnProperty("pedido") == false) {
          this.parametros.pedido = {
            observacao_garantia: null
          };
        }

        if (
          this.parametros.pdv.hasOwnProperty("default_header_title") == false
        ) {
          this.parametros.pdv.default_header_title = null;
        }

        if (this.parametros.hasOwnProperty("cartaCobranca") == false) {
          this.parametros.cartaCobranca = {
            assunto: null,
            emailResposta: null,
            textoEmail:
              "<p>Caro {{nome_cliente}},</p><p>Verificamos que você possui o(s) valor(es) vencido(s) conforme relacionado abaixo.</p><div>{{titulos}}</div><br><p>Por gentileza desconsidere esta mensagem caso já tenha sido efetuado o pagamento.</p><p>{{nome_empresa}}</p>"
          };
        }

        if (this.parametros.hasOwnProperty("nfse") == false) {
          this.parametros.nfse = {
            login: null,
            senha: null,
            token: null,
            nfseNacional: null
          };

          if (this.parametros.nfse.hasOwnProperty("login") == false) {
            this.parametros.nfse.login = null;
          }
          if (this.parametros.nfse.hasOwnProperty("senha") == false) {
            this.parametros.nfse.senha = null;
          }
          if (this.parametros.nfse.hasOwnProperty("token") == false) {
            this.parametros.nfse.token = null;
          }
          if (this.parametros.nfse.hasOwnProperty("nfseNacional") == false) {
            this.parametros.nfse.nfseNacional = null;
          }
        }

        if (
          this.showGuia &&
          this.steps.length > 0 &&
          this.filial.cnpj == "50117039000161"
        ) {
          var tourguide = new Tourguide({
            steps: this.steps
          });

          tourguide.start();
        }
      }

      this.loadParametrosNfse();

      this.loadLogotipo();

      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip();
      });
    },

    loadParametrosNfse() {
      if (!this.filial.codempresa) return;
      let self = this;
      cidades(this.$store, this.filial.codmun, function (data) {
        if (data) {
          self.nfse_login = data.login;
          self.nfse_senha = data.senha;
          self.nfse_token = data.token;
          self.nfse_certificado = data.certificado;
        }
      });
    },

    loadLogotipo() {
      if (!this.filial.codempresa) return;
      apiORDSmidia(
        this.$store.getters.urlApp +
        "logo/download/" +
        this.filial.codempresa +
        "/" +
        this.filial.codfil
      ).then(data => {
        if (data && data.size > 0) {
          let self = this;
          let reader = new window.FileReader();
          reader.readAsDataURL(data);
          reader.onload = function () {
            self.image = reader.result;
          };
        }
      });
    },

    async apiDelete() {
      //efetua a exclusao
      var modulo = "cg/filial/" + this.filial.codfil;

      const data = await apiORDSdelete(this.$store, modulo);
      this.$erpToastDeleted();
      this.closeForm();
    },

    async apiPost() {
      //efetua a gravacao

      var modulo = "cg/filial/";
      this.filial.list_iest = this.listSubstitutos;
      this.parametros.etiquetas = this.listEtiquetas;
      this.filial.parametros = this.parametros;
      if (this.filial.parametrosloja) {
        this.filial.parametrosloja = JSON.parse(this.filial.parametrosloja);
      } else {
        this.filial.parametrosloja = null;
      }
      if (this.tipo_ie === "SEM_IE") {
        this.filial.iest = null;
      } else if (this.tipo_ie === "ISENTO") {
        this.filial.iest = "ISENTO";
      }
      var sendData = { filial: this.filial };

      let metodo = "post";
      let update = false;
      if (this.crud != SysVars.crudI) {
        metodo = "put";
        update = true;
      }

      const data = await apiORDSpost(this.$store, modulo, sendData, metodo);
      if (data.errmessages) {
        this.errmessages = data.errmessages;
        this.$erpToastError("Alguns erros precisam ser corrigidos.");
      } else {
        if (!this.guide)
          if (update) {
            this.$erpToastUpdated();
          } else {
            this.$erpToastInserted();
          }
        this.errmessages = {};
        if (!this.guide)
          this.closeForm()
        else {
          this.$emit("gonextstep")
        }
      }
    },

    handleClickLogotipo(cod) {
      document.getElementById("anexo").click();
    },

    handleUpload(event) {
      this.selectedFile = event.target.files[0];
      this.urlImage = URL.createObjectURL(this.selectedFile);
      this.uploadImage();
    },

    uploadImage() {
      //EFETUA O UPLOAD DO CERTIFICADO

      let formData = new FormData();
      formData.append("file", this.selectedFile);

      var url = this.$store.getters.urlApp + "logo/";

      var self = this;

      axios
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            codfilial: this.filial.codfil,
            filename: this.selectedFile.name
          }
        })
        .then(function (data) {
          self.$erpToastSuccess("O logotipo foi atualizado com sucesso.");
          self.loadLogotipo();
        });
    },

    async apiDeleteImage() {
      //EFETUA A EXCLUSAO DO LOGOTIPO
      if (this.filial.logotipo.length == 0) return;
      var modulo = "logo/" + this.filial.logotipo[0].codlogotipo;
      const data = await apiORDSapp(this, modulo, "delete");
      this.image = null;
      this.$erpToastSuccess("O certificado foi removido com sucesso.");
    }
  },

  components: {
    "layout-etiqueta": LayoutEtiqueta,
    AppCertificado,
    Tourguide
  },

  watch: {
    tipo_ie: function () {
      if (this.tipo_ie === "ISENTO") {
        this.filial.iest = "ISENTO";
      } else if (this.tipo_ie === "SEM_IE") {
        this.filial.iest = null;
      } else if (this.tipo_ie === "COM_IE") {
        if (this.filial.iest === "ISENTO") {
          this.filial.iest = null;
        }
      }
    },
    "filial.nome": function () { },
    "filial.codmun": function () {
      this.loadParametrosNfse();
    }
  },

  beforeCreate() { },

  created() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip();
      if (this.$refs.cnpj)
        this.$refs.cnpj.focus();
    });

    if (!this.crud) this.crud = SysVars.crudU;

    this.crudText = this.$crudText(this.crud);

    this.loadData();
  },

  mounted() { }
};
</script>

<style>
.container h5 {
  text-transform: uppercase;
}

.text-editor {
  margin-left: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// src/forms/filial-form.vue